import { UserRole } from './auth'

import { API_URL } from '../config'

export interface User {
  _id: string
  email: string
  role: UserRole
  createdAt: string
  updatedAt: string
}

export interface CreateUserData {
  email: string
  password: string
  role: UserRole
}

export interface UpdateUserData {
  email?: string
  role?: UserRole
}

export const getUsers = async (token: string): Promise<User[]> => {
  const response = await fetch(`${API_URL}/admin`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to fetch users')
  }

  return response.json()
}

export const createUser = async (userData: CreateUserData, token: string): Promise<User> => {
  const response = await fetch(`${API_URL}/admin`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(userData)
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to create user')
  }

  return response.json()
}

export const updateUser = async (id: string, userData: UpdateUserData, token: string): Promise<User> => {
  const response = await fetch(`${API_URL}/admin/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(userData)
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to update user')
  }

  return response.json()
}

export const deleteUser = async (id: string, token: string): Promise<void> => {
  const response = await fetch(`${API_URL}/admin/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || 'Failed to delete user')
  }
}
